import React , { Component } from 'react';
import {SharedConfig} from "../Config/SharedConfig";
import Agent from "../Network/Agent";
import {ActionResponseEnum} from "../Network/Enum/ActionResponseEnum";
import {Helmet} from "react-helmet";
import {Spinner} from "react-bootstrap";
import {getGeneratedRoute, RouteEnumFinal} from "../Config/RouteEnum";

class ClearCache extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        sessionStorage.clear()
        localStorage.clear()
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
        window.location = getGeneratedRoute(RouteEnumFinal.SPLASH)
    }

    render() {
        return(
            <>
                <div className='container vh-100'>
                    <div className='row h-100 align-items-center'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-center'>
                                <div className='mobile-body-1-strong cl-black'>
                                    درحال بررسی , لطفا منتظر بمانید...
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default ClearCache